import { ChangeDetectorRef, Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { SlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-favourite-series-videos',
  templateUrl: './favourite-series-videos.component.html',
  styleUrls: ['./favourite-series-videos.component.scss']
})
export class FavouriteSeriesVideosComponent {
  @Input() modalid:any;
  @Input() type ="fav";
  @Input() selectedPlaylist:any;
  @Output() updatePlaylistVideosCount = new EventEmitter<any>();
  user:any;
  page=1
  keyword=''
  noVideos=false;
  totalvideo = 0;
  videosList: any = [];
  videosListAll: any = [];
  videoDetails: any;
  currentIndex = 8;
  items=[];
  filterVideos = [];
  
  opts: SlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;

  constructor(public webApi: WebapiService,public cdr: ChangeDetectorRef, public router: Router, private toastrService: ToastrService) {
  }

  addItem(newItem:any) {
    this.videoDetails = newItem;
  }

  addRemoveToPlaylist(data) {
    this.updatePlaylistVideosCount.emit(data)
  }

  ngOnInit()  
  {    
    this.getVideos()
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
		this.opts = new SlimScrollOptions({
			position: "right", // left | right
			barBackground: "rgb(108, 105, 105)", // #C9C9C9
			barOpacity: "0.3", // 0.8
			barWidth: "6", // 10
			barBorderRadius: "10", // 20
			barMargin: "0", // 0
			gridBackground: "#d9d9d9", // #D9D9D9
			gridOpacity: "1", // 1
			gridWidth: "0", // 2
			gridBorderRadius: "20", // 20
			gridMargin: "0", // 0
			alwaysVisible: true, // true
			alwaysPreventDefaultScroll: undefined, // true
    });

  } 

  // updateOnlyOnBlur(event) {
  //   this.page=1;
  //   this.videosList = [];
  //   this.getVideos()
  // }

  updateOnlyOnBlur(event) {
    this.currentIndex = 8;
    this.items = [];
    this.filterVideos = this.videosListAll.filter((item)=> { 
      return (item.name.toLowerCase().indexOf(this.keyword) >= 0) 
    })
    this.items = this.filterVideos.slice(0, this.currentIndex);
    this.videosList = this.filterVideos;
  }
  
  getVideos(){
    this.noVideos = false;
    this.webApi.setLoader(true);
    let params= {
      "keyword":this.keyword,
      "page":this.page
    }
    this.webApi.getFavouriteSeriesVideos(params).subscribe((video: any) => {
      this.videosList = [...this.videosList,...video.videos]; 
      this.videosListAll = [...this.videosListAll,...video.videos]; 
      //console.log('videos',video)
      if(this.videosListAll.length==0){
        this.noVideos = true;
      }
      this.items = this.videosListAll.slice(0, this.currentIndex);
      this.totalvideo = video.total; 
      this.webApi.setLoader(false);
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  
  LoadMoreLocal(){
    this.currentIndex += 8;
    if(this.keyword.length>0){
      if(this.filterVideos.length-1<this.currentIndex){
        this.currentIndex = this.filterVideos.length
      }
    }else{
      if(this.videosListAll.length-1<this.currentIndex){
        this.currentIndex = this.videosListAll.length
      }
    }
    
    this.items = this.videosListAll.slice(0, this.currentIndex);
    this.cdr.detectChanges();
  }

  showMore() {
    this.page = this.page+1
    this.getVideos();
  }

}
